;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"7f51659aaf37434471b6ebe0731bfb975ab7d955"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import { SHARED_SENTRY_CONFIG } from './sentry.shared.config';

Sentry.init({
  ...SHARED_SENTRY_CONFIG,
});
